import { Button } from "components/Button";
import { Card } from "components/Card";
import { Grid } from "components/Grid";
import { SHOW_ALL, translate } from "shared/translate";
import { TYPE_LINK } from "shared/constants";
import { useRouter } from "next/router";
import styles from "./CardsContainer.module.css";

export const CardsContainer = ({ allLinkType, items, title }) => {
  const { locale } = useRouter();
  const hasTitleOrLink = title || allLinkType;

  return (
    <div className={hasTitleOrLink ? styles.withBorder : null}>
      {hasTitleOrLink && (
        <header className={styles.header}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {allLinkType && (
            <div className={styles.desktopShowAll}>
              <Button href="" hrefType={allLinkType} type={TYPE_LINK}>
                {translate(SHOW_ALL, locale)}
              </Button>
            </div>
          )}
        </header>
      )}
      <Grid>
        {(items || []).map(
          ({
            date,
            endDate,
            featured,
            intro,
            heroImage,
            slug,
            title,
            _type,
          }) => (
            <Card
              alt={heroImage?.alt}
              date={date}
              description={intro}
              endDate={endDate}
              featured={featured}
              href={slug?.current}
              key={title}
              src={heroImage?.url}
              title={title}
              type={_type}
            />
          )
        )}
      </Grid>
      {allLinkType && (
        <div className={styles.mobileShowAll}>
          <Button href="" hrefType={allLinkType} type={TYPE_LINK}>
            {translate(SHOW_ALL, locale)}
          </Button>
        </div>
      )}
    </div>
  );
};
